export const formatProjectTreeSelect = (organizations) => {
  const otherProjects = Array.isArray(organizations) && organizations.length > 0 && organizations[organizations.length - 1]?.companies[0];

  const existingProjectIds = new Set();

  const data = Array.isArray(organizations) && organizations.length > 0 ? organizations.slice(0, -1).map(org => ({
    title: org.name,
    value: org.id,
    key: org.id,
    children: org.companies?.length > 0
      ? org.companies.map(comp => ({
          title: comp.name,
          value: comp.id,
          key: comp.id,
          children: comp.projects?.length > 0
            ? comp.projects.map(proj => {
                existingProjectIds.add(proj.id);
                return {
                  title: proj.description,
                  value: proj.id,
                  key: proj.id,
                };
              })
            : undefined
        }))
      : undefined
  })) : [];

  const updatedOtherProjects = otherProjects ? {
    title: "Demais Projetos",
    value: '1-2',
    disableCheckbox: true,
    key: 0,
    children: otherProjects.projects?.length > 0
      ? otherProjects.projects.filter(comp => {
          if (existingProjectIds.has(comp.id)) {
            return false;
          }
          existingProjectIds.add(comp.id);
          return true;
        }).map((comp, index) => ({
          title: comp.description,
          value: comp.id,
          key: comp.id,
        }))
      : undefined
  } : null;

  return updatedOtherProjects ? [...data, updatedOtherProjects] : data;
}

export const findNode = (nodes, value) => {
  for (const node of nodes) {
    if (node.value === value) return node;
    if (node.children) {
      const found = findNode(node.children, value);
      if (found) return found;
    }
  }
  return null;
};

export const getProjectIds = (treeData, scopeId, scopeType) => {
  const selectedNode = findNode(treeData, scopeId);
  if (!selectedNode) return [];

  if (scopeType === "organization") {
    return selectedNode.children?.flatMap(company => 
      company.children?.map(project => project.value) || []
    ) || [];
  }

  if (scopeType === "company") {
    return selectedNode.children?.map(project => project.value) || [];
  }

  if (scopeType === "project") {
    return [scopeId];
  }

  return [];
};

export const getProjectIdsFromTree = (treeData, selectedId) => {
  const selectedNode = findNode(treeData, selectedId);
  if (!selectedNode) return [];

  // Retorna os filhos (empresas ou projetos)
  return selectedNode.children
    ? selectedNode.children.flatMap(child =>
        child.children ? child.children.map(project => project.value) : [child.value]
      )
    : [selectedId]; // Nó folha retorna ele mesmo
};